import { isSoftwareVersionSupported } from 'src/Libs/home-power-station/utils/is-software-version-supported'
import { DYNAMIC_EMS_SOFTWARE_REQUIREMENT, DYNAMIC_EMS_V2_SOFTWARE_REQUIREMENT } from '../../config'
import { DynamicEmsAccessibleReturnType } from '../../hooks/dynamic-ems/use-is-dynamic-ems-accessible'

/**
 * Determines whether the dynamic ems features are accessible for the given software version and theme.
 * Dynamic ems v2 is not available for the flow theme.
 */
export const getDynamicEmsAccessibility = (softwareVersion: string | undefined, isFlowTheme: boolean): DynamicEmsAccessibleReturnType => ({
  isDynamicEmsAccessible: isSoftwareVersionSupported(
    `${DYNAMIC_EMS_SOFTWARE_REQUIREMENT.MinimumYear}.${DYNAMIC_EMS_SOFTWARE_REQUIREMENT.MinimumMonth}`,
    softwareVersion ?? ''
  ),
  isDynamicEmsV2Accessible:
    !isFlowTheme &&
    isSoftwareVersionSupported(
      `${DYNAMIC_EMS_V2_SOFTWARE_REQUIREMENT.MinimumYear}.${DYNAMIC_EMS_V2_SOFTWARE_REQUIREMENT.MinimumMonth}`,
      softwareVersion ?? ''
    ),
})
